export const joinEmail = 'join@grafbase.com'
export const contactEmail = 'hello@grafbase.com'
export const supportEmail = 'support@grafbase.com'
export const domainUrl = 'https://grafbase.com'
export const effectiveDate = '1st of December, 2021'
export const businessAddress = '3039 Octavia Street, 94123 San Francisco, CA'
